

import { useClienteContext } from "../../../contexts/ClienteContext";
import { User, Hash, CreditCard, MapPin, Phone, Box, X } from "lucide-react"; // Iconografía profesional

export default function PerfilCliente({ setIsModalOpenPerfil }) {
  const { getCliente } = useClienteContext();
  const data = getCliente();

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[200] bg-[#050f08]/90 backdrop-blur-sm p-4">
      {/* Contenedor Principal con Glassmorphism */}
      <div className="bg-[#0a160c] w-full max-w-md rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10 overflow-hidden relative">
        
        {/* Decoración de fondo sutil */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#c9a84c]/10 blur-[80px] rounded-full"></div>

        <div className="p-4 relative z-10">
          {/* Cabecera del Perfil */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 rounded-2xl bg-[#c9a84c]/10 flex items-center justify-center mb-4 border border-[#c9a84c]/20">
              <User className="text-[#c9a84c]" size={32} />
            </div>
            <h2 className="text-white text-xl font-black tracking-tight text-center uppercase">
              {data?.nombreCliente}
            </h2>
            <div className="h-1 w-12 bg-[#c9a84c] rounded-full mt-3 opacity-50"></div>
          </div>

          {/* Grilla de Datos Técnicos */}
          <div className="space-y-2">
            {[
              { label: "Código", value: data?.codigoCliente, icon: <Hash size={16} /> },
              { label: "CUIT", value: data?.cuitcliente, icon: <CreditCard size={16} /> },
              { label: "Domicilio", value: data?.domicilioCliente, icon: <MapPin size={16} /> },
              { label: "Teléfono", value: data?.telefonoCliente, icon: <Phone size={16} /> },
              { label: "Depósito", value: data?.codDeposito, icon: <Box size={16} /> },
            ].map((item, idx) => (
              <div 
                key={idx} 
                className="flex items-center justify-between p-2 rounded-xl bg-white/[0.03] border border-white/5 group hover:bg-white/[0.05] transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="text-[#c9a84c] opacity-60 group-hover:opacity-100 transition-opacity">
                    {item.icon}
                  </div>
                  <span className="text-white/40 text-[10px] font-black uppercase tracking-widest">
                    {item.label}
                  </span>
                </div>
                <span className="text-white/80 text-sm font-bold tracking-tight text-right">
                  {item.value || "—"}
                </span>
              </div>
            ))}
          </div>

          {/* Botón de Cierre Minimalista */}
          <div className="mt-10 flex justify-center">
            <button
              onClick={() => setIsModalOpenPerfil(false)}
              className="group flex items-center gap-2 px-8 py-3 bg-white/5 hover:bg-red-500/10 border border-white/10 hover:border-red-500/50 text-white/50 hover:text-red-500 rounded-full font-black text-[10px] uppercase tracking-[0.3em] transition-all active:scale-95 shadow-xl"
            >
              <X size={14} className="group-hover:rotate-90 transition-transform" />
              Cerrar Perfil
            </button>
          </div>
        </div>
      </div>
      
      {/* Overlay para cerrar al hacer clic afuera */}
      <div 
        className="absolute inset-0 z-[-1]" 
        onClick={() => setIsModalOpenPerfil(false)}
      ></div>
    </div>
  );
}